import { IWixAPI } from '@wix/yoshi-flow-editor';
import { assertDefined } from '../../../ts-utils';

export const getCurrentInstance = (wixCodeApi: IWixAPI, appDefinitionId: string) => {
  const instance =
    wixCodeApi.user.currentUser.instance || wixCodeApi.site.getAppToken?.(appDefinitionId);
  assertDefined(instance);
  return instance;
};
